<template>
  <section id="WinThanks" class="win-thanks">
    <div class="circle-and-sun">
      <img src="../assets/win/circle-and-flowers.png">
      <div class="thanks-text">
        <div class="step-num">Step 03</div>
        <h2>Thanks for Entering</h2>
        <p>If you signed up for the challenge, we’ll be sending your 
  first activity in a week, so check your email.</p>
      </div>
    </div>
      <div class="get-started">
        <h2>Eager to Get Started?</h2>
        <p>Wander over to your grocery store to get your hands on Zespri SunGold Kiwifruit.</p>
        <div class="button-container">
          <a v-if="couponUrl.length > 0" :href="couponUrl" target="_blank" class="get-started-button">
            <i class="button-icon coupon-icon">
              <coupon-icon></coupon-icon>
            </i>
            Download the coupon
          </a>
          <a href="/en-US/wheretobuy" target="_blank" class="get-started-button">
            <i class="button-icon find-store-icon">
              <find-icon></find-icon>
            </i>
            Find a Store
          </a>
        </div>
      </div>
  </section>
</template>

<script>
import store from '../store'
import FindIcon from '../assets/icons/find-store.svg?inline'
import CouponIcon from '../assets/icons/coupon.svg?inline'

export default{
  name: 'win-thanks',
  computed: {
    couponUrl(){
      return store.state.couponUrl
    },
  },
  components: {
    'find-icon': FindIcon,
    'coupon-icon': CouponIcon
  },
}
</script>

<style scoped lang="scss">
/** split-container **/
@import '../theme';

.win-thanks {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0 200px 0;
  z-index: zespri-layer(normal);

  @include media-breakpoint-up(md) {
    padding: 0;
  }

  .circle-and-sun {
    position: relative;
    max-width: 445px;
    margin: 0 -32px;

    @include media-breakpoint-up(md) {
      margin: 0;
    }

    img {
      width: 100%;
    }

    .thanks-text {
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;

      @include media-breakpoint-up(md) {
        top: 25%;
      }

      .step-num {
        @include zespri-mid-title;
      }
    }
  }

  .get-started {
    margin-top: 30px;
    max-width: 445px;

    .button-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;

      @include media-breakpoint-up(md) {
        flex-direction: row;
        justify-content: center;
      }

      .get-started-button {
        @include cta-button(zespri-brand-color(dark-green), zespri-brand-color(white), zespri-brand-color(dark-green));
        margin: 15px 0;

        @include media-breakpoint-up(md) {
          margin: 0 20px;
        }
      }
    }
  }
}

.button-icon {
  display: inline-block;
  margin-right: 8px;
  fill: zespri-brand-color(red);

  &.find-store-icon {
    width: 11px;
    height: 18px;
  }

  &.coupon-icon {
    width: 22px;
    height: 18px;
  }
}

</style>
